// Formatted Data
const getAPIAccess = state => state.apiAccess;

export default {
  getAPIAccess,
};
